// Temple photo used behind the login page and the phone home screen.
export const TEMPLE_BG = "https://images.unsplash.com/photo-1554554497-0095c34db3ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB0ZW1wbGUlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg5Mjk3ODk5fDA&ixlib=rb-4.1.0&q=85";
